<template>
  <div id="calories-burned">
    <form @submit.prevent="calculate">
      <div>
        <select v-model="gender" id="gender">
          <option value>Gender</option>
          <option value="m">male</option>
          <option value="k">female</option>
        </select>
      </div>
      <div>
        <input type="number" v-model.number="age" placeholder="Age (years)" />
      </div>
      <div>
        <input type="number" v-model.number="weight" placeholder="Weight (kg)" />
      </div>
      <div>
        <input v-model.number="heart_rate" placeholder="Pulse BPM" />
      </div>
      <div>
        <input v-model.number="time" placeholder="Workout time (min)" />
      </div>
      <input type="submit" value="Send" />
    </form>
    <div v-if="displayFields">
      <div class="calories-burned">
        Calories burned:
        <div>{{this.result}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaloriesBurnEn",
  methods: {
    calculate: function () {
      let duration = this.time / 60; //

      if (this.gender === "m") {
        this.result =
          ((-55.0969 +
            0.6309 * Number(this.heart_rate) +
            0.1988 * Number(this.weight) +
            0.2017 * Number(this.age)) /
            4.184) *
          60 *
          Number(duration);
      } else if (this.gender === "k") {
        this.result =
          ((-20.4022 +
            0.4472 * Number(this.heart_rate) -
            0.1263 * Number(this.weight) +
            0.074 * Number(this.age)) /
            4.184) *
          60 *
          Number(duration);
      }

      this.result = Math.round(this.result);
      this.displayFields = true;
    },
  },
  data() {
    return {
      result: 0,
      gender: "",
      age: null,
      weight: null,
      heart_rate: null,
      time: null,
      displayFields: false,
    };
  },
};
</script>

